import React from "react";
import CategoryPage from "./CategoryPage";

function InkAndEchoPoems({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Poems"
      parentCategory="Articles"
      subcategoryValues={[
        "Ink and Echo"
      ]}
      subSubcategoryValues={[
        "Poems"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default InkAndEchoPoems;